import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Menu from './components/Menu';
import FeaturedEvents from './components/FeaturedEvents';
import EventHeader from './components/EventHeader';
import EventCarousel from './components/EventCarousel';
import ClubnightCarousel from './components/ClubnightCarousel';
import Newsletter from './components/Newsletter';
import AgendaFilter from './components/AgendaFilter';
import Faq from './components/Faq';
import EventInfo from './components/EventInfo';
//import CustomCursor from './components/CustomCursor';


export class Helling {
	constructor() {
		// Promises waarop gewacht  wordt. Standaard wordt er gewacht op het 'DOMContentLoaded' event
		Promise.all([Helling.domReady()]).then(() => this.init());
	}

	init() {
		document.dispatchEvent(new Event('bless'));

		this.menu = new Menu();

		// const customCursor = document.querySelector('[data-custom-cursor]');
		// if(customCursor) {
		// 	new CustomCursor(customCursor);
		// }

		const featuredEvents = document.querySelector('[data-featured-events]');
		if(featuredEvents) {
			new FeaturedEvents(featuredEvents);
		}

		const eventCarousels = document.querySelectorAll('[data-event-carousel]');
		eventCarousels.forEach(eventCarousel => {
			new EventCarousel(eventCarousel);
		});

		const clubnightCarousels = document.querySelectorAll('[data-clubnight-carousel]');
		clubnightCarousels.forEach(clubnightCarousel => {
			new ClubnightCarousel(clubnightCarousel);
		});

		const newsletterElm = document.querySelector('[data-newsletter]');
		if(newsletterElm) {
			new Newsletter(newsletterElm);
		}

		const filterElm = document.querySelector('[data-agenda-filter]');
		if(filterElm) {
			new AgendaFilter(filterElm, this.menu);
		}

		const eventHeader = document.querySelector('.c-event-header');
		if(eventHeader) {
			new EventHeader(eventHeader);
		}

		const eventInfos = document.querySelectorAll('[data-event-info]');
		eventInfos.forEach(eventInfo => {
			new EventInfo(eventInfo);
		});

		const faqs = document.querySelectorAll('[data-faq]');
		faqs.forEach(faq => {
			new Faq(faq);
		});

		const shareButtons = document.querySelectorAll('[data-native-share]');
		shareButtons.forEach(button => {
			if (!navigator.share) {
				button.remove();
			} else {
				button.addEventListener('click', () => {
					navigator.share({
						title: document.title,
						url: window.location.href
					}).then(() => {
						//console.log('Thanks for sharing!');
					})
					.catch(console.error);
				});
			}
		});
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Helling();